export default [{
  path: '/profile',
  meta: { requiresAuth: true },
  component: () => import('@/layouts/MainTemplate'),
  children: [{
    path: '',
    component: () => import('@/views/Profile/ProfilePage')
  }]
}]
